import { StoreState } from 'state/types';
import { Channel } from './channelActions';

const getState = (state: StoreState) => state.sockets;
const getChannels = (state: StoreState) => getState(state).channels;
export const getChannelIsActive = (state: StoreState, channelName: Channel) =>
  getChannels(state).includes(channelName);
